export enum ImageSizeType {
  OneColumn = 'OneColumn',
  ThreeToOneColumns = 'ThreeToOneColumns',
  TwoToOneColumns = 'TwoToOneColumns'
}
